<template>
   <div class="text-center">
      <div>
         <button v-bind:class="{'selected': storeState.area == 'espoo'}" class="btn-gray w-48 mt-3 mb-3" @click="store.selectCity('espoo')">Espoo</button>
      </div>

      <div>
         <button v-bind:class="{'selected': storeState.area == 'kirkkonummi'}" class="btn-gray w-48 mt-3 mb-3" @click="store.selectCity('kirkkonummi')">Kirkkonummi</button>
      </div>

      <div>
         <button v-bind:class="{'selected': storeState.area == 'helsinki'}" class="btn-gray w-48 mt-3 mb-3" @click="store.selectCity('helsinki')">Helsinki</button>
      </div>

      <div>
         <button v-bind:class="{'selected': storeState.area == 'vantaa'}" class="btn-gray w-48 mt-3 mb-3" @click="store.selectCity('vantaa')">Vantaa</button>
      </div>

      <div>
         <button v-bind:class="{'selected': storeState.area == 'pori'}" class="btn-gray w-48 mt-3 mb-3" @click="store.selectCity('pori')">Pori</button>
      </div>
   </div>
</template>

<script>
export default {
   name: 'home',

   props: ['store'],

   components: {

   },

   data () {
      return {
         storeState: this.store.state,
         queryFragment: ''
      }
   },

   methods: {
      toggleHouse (house) {
         this.store.toggleHouse(house)
         this.queryFragment = ''
      }
   },

   computed: {
      filteredHouses () {
         return this.storeState.availableHouses.filter(x => {
            return x.name.toLowerCase().includes(this.queryFragment.toLowerCase()) ||
               x.city.toLowerCase().includes(this.queryFragment.toLowerCase())
         })
      }
   }
}

</script>

<style scoped>
</style>
